import { IFlagParametersRepository } from 'shared/domain/repositories';

export default class FindDigitalSigningDisabilityUseCase {
  constructor(private flagParametersRepository: IFlagParametersRepository) {}

  public async execute() {
    return this.flagParametersRepository.findByKey('DIGITAL_SIGNING_DISABLED');
  }
}
